<div class="mat-field-wrapper {{ class }}">
	<mat-form-field appearance="outline" [hideRequiredMarker]="true">
		<mat-label>{{ label || 'Label' }}</mat-label>
		<input matInput placeholder="" [formControl]="control" (keyup)="onKeyUp($event)" />
	</mat-form-field>
	<div class="error-container" *ngIf="control.invalid && (control.dirty || control.touched)">
		<span>{{ errorMessage }}</span>
	</div>
</div>
